import { useCallback, useSyncExternalStore } from "react";

export function subscribeToMediaQuery(
  query: string,
  onChange: () => void,
): () => void {
  const list = window.matchMedia(query);
  list.addEventListener("change", onChange);
  return () => list.removeEventListener("change", onChange);
}

export const matchesMediaQuery = (query: string): boolean =>
  window.matchMedia(query).matches;

// `serverSnapshot` is required because the right server answer is a
// per-caller layout guess: it is what prerendered and hydrating markup show
// until the first client read corrects it.
export function useMediaQuery(query: string, serverSnapshot: boolean): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => subscribeToMediaQuery(query, onChange),
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => matchesMediaQuery(query),
    () => serverSnapshot,
  );
}
